interface SortableIntegration {
  name: string;
  hasAtLeastOneInstance?: boolean;
  unavailable?: boolean;
}

interface UseIntegrationManagementReturn {
  sortIntegrations: <T extends SortableIntegration>(integrations: T[]) => T[];
}

const useIntegrationManagement = (): UseIntegrationManagementReturn => {
  const sortIntegrations = <T extends SortableIntegration>(integrations: T[]): T[] => {
    return [...integrations]
      .sort(function (a, b) {
        return b?.name.toLowerCase() > a?.name.toLowerCase() ? -1 : 1;
      })
      .sort(function (a, b) {
        let res = 0;
        if (a.hasAtLeastOneInstance && !b.hasAtLeastOneInstance) {
          res = -1;
        } else if (a.unavailable && !b.unavailable) {
          res = 1;
        } else if (!a.hasAtLeastOneInstance && b.hasAtLeastOneInstance) {
          res = 1;
        } else if (!a.unavailable && b.unavailable) {
          res = -1;
        }

        return res;
      });
  };

  return {
    sortIntegrations,
  };
};

export default useIntegrationManagement;
